import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import emailjs from '@emailjs/browser'; // Import EmailJS
import Bg from '../../../images/shapes/bg_pattern_3.svg';
import Bg2 from '../../../images/shapes/shape_space_6.svg';
import icon1 from '../../../images/shapes/shape_space_5.svg';
import icon2 from '../../../images/icons/icon_mail_2.svg';
import logo from '../../../images/site_logo/praeventor_white.svg';

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const Footer = (props) => {
  const [email, setEmail] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const SubmitHandler = (e) => {
    e.preventDefault();

    if (!email) {
      setErrorMessage('Voer een geldig e-mailadres in.');
      setSuccessMessage('');
      return;
    }

    emailjs
        .send(
            'praeventor_website_mail', // Replace with your EmailJS Service ID
            'template_2ifad8w', // Replace with your EmailJS Template ID
            { email },
            'AXXkBqHzaUtuV7d-V' // Replace with your EmailJS User ID
        )
        .then((response) => {
          setSuccessMessage('Bedankt voor je inschrijving! We houden je op de hoogte.');
          setErrorMessage('');
          setEmail(''); // Reset the email field
        })
        .catch((error) => {
          setErrorMessage('Er is iets misgegaan. Probeer het later opnieuw.');
          setSuccessMessage('');
        });
  };

  return (
      <footer className="site_footer footer_layout_2 section_decoration" style={{ backgroundImage: `url(${Bg})` }}>
        <div className="decoration_item shape_image_1">
          <img src={icon1} alt="Praeventor Shape" />
        </div>
        <div className="container">
          <div className="footer_main_content">
            <div className="row justify-content-lg-between">
              <div className="col-lg-3 col-md-6">
                <div className="footer_widget pe-lg-3">
                  <img src={logo} width={"600px"} alt="Praeventor Large Logo"></img>
                  <p style={{ marginTop: "20px" }}>
                    Wij geloven dat elk bedrijf – van scale-up tot klein MKB – het verdient om veilig en zorgeloos te groeien.
                    Bij Praeventor nemen we de complexiteit van cybersecurity uit handen,
                    zodat jij je kunt richten op waar je goed in bent.
                  </p>
                  <ul className="contact_method_list unordered_list_block">
                    <li>
                      <a href="tel:+31627468033">
                      <span className="icon">
                        <i className="fa-solid fa-phone-volume"></i>
                      </span>
                        <span className="text text-white">+31 6 27 46 80 33</span>
                      </a>
                    </li>
                    <li>
                      <a href="mailto:info@praeventor.nl">
                      <span className="icon">
                        <i className="fa-solid fa-envelope"></i>
                      </span>
                        <span className="text text-white">info@praeventor.nl</span>
                      </a>
                    </li>
                  </ul>
                  <div style={{ marginTop: "10px" }}>
                    <ul className="social_icons_block unordered_list_block">
                      <li>
                        <a href="https://www.linkedin.com/company/praeventor/">
                          <i className="fa-brands fa-linkedin-in "></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-md-6">
                <div className="footer_widget">
                  <h3 className="footer_info_title">Company</h3>
                  <ul className="icon_list unordered_list_block">
                    <li>
                      <Link onClick={ClickHandler} to="/about">
                      <span className="icon_list_text">
                        Over Ons
                      </span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/partners">
                      <span className="icon_list_text">
                        Partners
                      </span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/sectoren">
                      <span className="icon_list_text">
                        Sectoren
                      </span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/contact">
                      <span className="icon_list_text">
                        Contacts
                      </span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/faq">
                      <span className="icon_list_text">
                        FAQ
                      </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-2 col-md-6">
                <div className="footer_widget">
                  <h3 className="footer_info_title">Diensten</h3>
                  <ul className="icon_list unordered_list_block">
                    <li>
                      <Link onClick={ClickHandler} to="/services/securescan">
                      <span className="icon_list_text">
                        Secure Scan
                      </span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/services/quickscan">
                      <span className="icon_list_text">
                        Quick Scan
                      </span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/services/security-awareness-training">
                      <span className="icon_list_text">
                        Training & Educatie
                      </span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/services/compliance-en-regelgeving">
                      <span className="icon_list_text">
                        Compliance en Regelgeving
                      </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="footer_widget pe-lg-3">
                  <h2 className="footer_info_title">Nieuwsbrief</h2>
                  <p>
                    Blijf op de hoogte, meld je aan voor onze nieuwsbrief om onze voortgang te volgen
                    en onze passie van dichtbij mee te maken.
                  </p>
                  <form className="footer_newslatter_2" onSubmit={SubmitHandler}>
                    <label htmlFor="footer_mail_input">
                      <img src={icon2} alt="Mail SVG Icon" />
                    </label>
                    <input
                        id="footer_mail_input"
                        type="email"
                        name="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <button type="submit">VERSTUUR</button>
                  </form>
                  {successMessage && <p className="successMessage">{successMessage}</p>}
                  {errorMessage && <p className="errorMessage">{errorMessage}</p>}
                  <div className="cta_text_input">
                    <p>* We beloven geen spam, alleen updates die ertoe doen.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer_bottom" style={{ backgroundImage: `url(${Bg2})` }}>
          <div className="container d-md-flex align-items-md-center justify-content-md-between">
            <p className="copyright_text m-0">
              Copyright © 2025 Praeventor, All rights reserved.
            </p>
            <ul className="icon_list unordered_list">
              <li>
                <Link onClick={ClickHandler} to="/algemene-voorwaarden">
                <span className="icon_list_icon">
                  <i className="fa-solid fa-circle"></i>
                </span>
                  <span className="icon_list_text" >
                  Algemene Voorwaarden
                </span>
                </Link>
              </li>
              <li>
                <Link onClick={ClickHandler} to="/privacy-policy">
                <span className="icon_list_icon">
                  <i className="fa-solid fa-circle"></i>
                </span>
                  <span className="icon_list_text">
                  Privacy Policy
                </span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </footer>
  );
};

export default Footer;
